import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import withApplicantHOC from "Hoc/ApplicantHOC/ApplicantHOC";

import AboutYou from "./AboutYou";
import { getVaultMember } from "./Actions/AboutYouActions";
import {
  getProductFromVault,
  updateProductToVault,
  updateVaultProductList,
} from "../MarketPlace/Action/MarketPlaceAction";
import { S_MEMBER_INFO_WELCOME_SHOWN } from "../../Communication/Constants";
import { searchMember } from "../../Redux/Actions/ApplicantAction";
import {
  getGettingStartedData,
  getPlaidToken,
  getPlaidVerification,
} from "../../Redux/Actions/ApplicationAction";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

class AboutYouContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      returningMember: false,
    };
  }

  componentDidMount() {
    const {
      applicantData,
      applicationCompleteList,
      inSessionJointApplicant,
      doDisableBack,
      actionBack,
      doGetVaultMember,
      finInfo,
    } = this.props;
    const tempHide = sessionStorage.getItem("TEMP_HIDE");
    const memberInfoWelcomeShown = sessionStorage.getItem(
      S_MEMBER_INFO_WELCOME_SHOWN
    );
    console.log(
      "componentDidMount",
      applicantData?.acquireType,
      applicationCompleteList.length,
      tempHide,
      inSessionJointApplicant,
      memberInfoWelcomeShown
    );
    if (applicantData && !inSessionJointApplicant) {
      doGetVaultMember((response) => console.log(response));
    }
    if (
      applicantData?.id &&
      !memberInfoWelcomeShown &&
      !inSessionJointApplicant &&
      !actionBack
    ) {
      this.setState({
        returningMember: true,
      });
    }
    if (inSessionJointApplicant) {
      doDisableBack(true);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      applicantData,
      inSessionJointApplicant,
      vaultProductList,
      getActiveProduct,
      doUpdateProductToVault,
    } = this.props;
    const activeProduct = getActiveProduct(vaultProductList);
    if (
      !activeProduct?.applicantId &&
      applicantData?.id &&
      !inSessionJointApplicant
    ) {
      if (vaultProductList && vaultProductList.length > 0) {
        vaultProductList[
          vaultProductList.findIndex((x) => x === activeProduct)
        ].applicantId = applicantData.id;
        doUpdateProductToVault(vaultProductList);
      }
    }
  }

  processEndKyc = () => {
    const { endKyc } = this.props;

    endKyc();
  };

  render() {
    const { returningMember } = this.state;
    const {
      formData,
      getDataFromServer,
      continuehandler,
      isEdit,
      handleBack,
      scanDocument,
      steps,
      activeStepID,
      vaultProductList,
      getActiveProduct,
      finInfo,
      inSessionJointApplicant,
      sessionCompletedProducts,
      history,
      applicantData,
      doCreateNewApplicant,
      doUpdateProductToVault,
      doUpdateVaultProductList,
      doGetProductFromVault,
      processTemplate,
      doSearchMember,
      isQrKyc,
      kycVault,
      doGetPlaidToken,
      doGetPlaidVerification,
      doLoadingStart,
      doLoadingFinish,
    } = this.props;

    return (
      <AboutYou
        formData={formData}
        isInEditFlow={isEdit}
        getDataFromServer={getDataFromServer}
        continuehandler={continuehandler}
        handleBack={handleBack}
        scanDocument={scanDocument}
        steps={steps}
        activeStepID={activeStepID}
        vaultProductList={vaultProductList}
        getActiveProduct={getActiveProduct}
        returningMember={returningMember}
        finInfo={finInfo}
        inSessionJointApplicant={inSessionJointApplicant}
        sessionCompletedProducts={sessionCompletedProducts}
        history={history}
        applicantData={applicantData}
        doCreateNewApplicant={doCreateNewApplicant}
        doUpdateProductToVault={doUpdateProductToVault}
        doGetProductFromVault={doGetProductFromVault}
        doUpdateVaultProductList={doUpdateVaultProductList}
        processTemplate={processTemplate}
        doSearchMember={doSearchMember}
        isQrKyc={isQrKyc}
        kycVault={kycVault}
        doGetPlaidToken={doGetPlaidToken}
        doGetPlaidVerification={doGetPlaidVerification}
        doLoadingStart={doLoadingStart}
        doLoadingFinish={doLoadingFinish}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  formData: state.AboutYouReducer.formData,
  updateApplicant: state.ComplianceReducer,
  isEdit: state.ApplicationReducer.isEdit,
  scanDocument: state.ApplicationReducer.scanDocument,
  vaultProductList: state.VaultReducer.vaultProductList,
  applicantData: state.ApplicationReducer.response,
  applicationCompleteList: state.ApplicationReducer.applicationCompleteList,
  inSessionJointApplicant: state.JoinApplicantReducer.inSessionJointApplicant,
  finInfo: state.MarketplaceReducer.finInfo,
  actionBack: state.ApplicationReducer.actionBack,
  sessionCompletedProducts: state.ApplicationReducer.sessionCompletedProducts,
  processTemplate: state.ApplicationReducer.processTemplate,
  isQrKyc: state.ApplicationReducer.isQrKyc,
  kycVault: state.AboutYouReducer.kycVault,
});

const mapDispatchToProps = (dispatch) => {
  return {
    doUpdateProductToVault: (vaultList, callback) =>
      dispatch(updateProductToVault(vaultList, callback)),
    doGetVaultMember: (callback) => dispatch(getVaultMember(callback)),
    doGetProductFromVault: (callback) =>
      dispatch(getProductFromVault(callback)),
    doUpdateVaultProductList: (vaultList, callback) =>
      dispatch(updateVaultProductList(vaultList, callback)),
    doSearchMember: (params, callback) =>
      dispatch(searchMember(params, callback)),
    doGetGettingStartedVault: (callback) =>
      dispatch(getGettingStartedData(callback)),
    doGetPlaidToken: (data, callback) =>
      dispatch(getPlaidToken(data, callback)),
    doGetPlaidVerification: (linkSessionId, callback) =>
      dispatch(getPlaidVerification(linkSessionId, callback)),
    doLoadingStart: (loading, message) =>
      dispatch(doLoadingStart(loading, message)),
    doLoadingFinish: (loading) => dispatch(doLoadingFinish(loading)),
  };
};

AboutYouContainer.propTypes = {
  formData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  isEdit: PropTypes.bool,
  getDataFromServer: PropTypes.func.isRequired,
  continuehandler: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  scanDocument: PropTypes.bool.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
  vaultProductList: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.string,
  ]),
  getActiveProduct: PropTypes.func,
  finInfo: PropTypes.oneOfType([PropTypes.object]),
  sessionCompletedProducts: PropTypes.arrayOf(PropTypes.object),
  inSessionJointApplicant: PropTypes.oneOfType([PropTypes.object]),
  history: PropTypes.oneOfType([PropTypes.object]),
  applicantData: PropTypes.oneOfType([PropTypes.object]),
};

AboutYouContainer.defaultProps = {
  history: {},
  formData: null,
  isEdit: false,
  steps: [],
  activeStepID: -1,
  vaultProductList: [],
  getActiveProduct: () => {},
  finInfo: {},
  inSessionJointApplicant: null,
  applicantData: null,
  sessionCompletedProducts: [],
};

const AboutYouWrapper = withApplicantHOC(AboutYouContainer);

export default connect(mapStateToProps, mapDispatchToProps)(AboutYouWrapper);
